<template>
  <div class="error-container">
    <div class="error-content">
      <i class="fas fa-exclamation-circle error-icon"></i>
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "SensorIssuesMessageView",
  props: {
    title: {
      type: String,
      default: "Could Not Fetch Issues",
    },
    message: {
      type: String,
      default: "There was a problem retrieving the sensor issues.",
    },
  },
};
</script>
  
  <style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.error-content {
  text-align: center;
  color: #666;
}

.error-icon {
  font-size: 48px;
  color: #dc3545;
  margin-bottom: 16px;
}

h2 {
  margin-bottom: 8px;
}

p {
  margin: 0;
}
</style>
  
  